module.exports = __webpack_public_path__ + "static/logo-header-a6767f2fed3356202cf1af5a08c4ec0c.svg";